import * as React from "react";
import {connect} from "react-redux";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import User from "../../../model/user/User";
import SearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import InputWithIcon from "../../../hiberUiKit/src/atoms/Input/InputWithIcon";
import {isNullOrUndefined} from "util";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";

interface ComponentProps {
	/**
	 * Id of selected sales engineer.
	 */
	selectedSalesEngineerId: Option<string>;
	/**
	 * Lead partner brand Id.
	 */
	leadPartnerBrandId: Option<string>;
	/**
	 * Sales engineer change callback.
	 * @param {string} salesEngineerId
	 */
	onChange: (salesEngineerId: string) => void;
	/**
	 * Indicates if dropdown should be rendered on top of the input.
	 */
	dropDownTop?: boolean;
}

interface ReduxProps {
	/**
	 * Sales engineer list.
	 */
	salesEngineers: User[];
}

interface State {
	/**
	 * Indicates if dropdown is visible.
	 */
	dropDownVisible: boolean;
}

type Props = ComponentProps & ReduxProps & PlaceholderProps

class AppointmentSalesEngineerDropdown extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.onDropDownToggle = this.onDropDownToggle.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		const selectedSalesEngineerId = this.props.selectedSalesEngineerId.orNull;
		return (
			<React.Fragment>
				<div>
					<InputWithIcon type={"text"} appendIcon={Icon.ArrowDown}
								   value={this.selectedItemToValue(selectedSalesEngineerId)}
								   placeholder={this.props.placeholder}
								   onClick={this.onDropDownToggle}
								   onAppendIconClick={this.onDropDownToggle}
								   clearable={true}
								   onClearClick={() => this.onChange(null)}/>
				</div>
				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({dropDownVisible: false})}
								 dropDownTop={this.props.dropDownTop}>
					<SearchDropDown items={this.props.salesEngineers.filter(se => !se.disabled)}
									itemToId={(item: User) => item.id}
									itemToLabel={(item: User) => item.getDisplayName()}
									selectedItemId={selectedSalesEngineerId}
									isItemSpecial={(item: User) => item.isThirdPartyEngineer() && !item.isSalesEngineer()}
									placeholder={"Search..."}
									onChange={(u: User) => this.onChange(u.id)}/>
				</DropDownWrapper>}
			</React.Fragment>
		);
	}

	/**
	 * Map selected item (if any) to displayable value.
	 * @return {string}
	 */
	selectedItemToValue(salesEngineerId: string): string {
		const [selectedItem] = this.props.salesEngineers.filter(se => se.id === salesEngineerId);
		return isNullOrUndefined(selectedItem) ? "" : selectedItem.getDisplayName(true);
	}

	onDropDownToggle() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onChange(seId: string) {
		this.setState({dropDownVisible: false});
		this.props.onChange(seId);
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		salesEngineers: state.user.users.getOrElse([]).filter(u => u.isSalesEngineer()
			|| (u.isThirdPartyEngineer() && props.leadPartnerBrandId.isDefined && u.data.partnerBrandId.isDefined
				&& props.leadPartnerBrandId.get === u.data.partnerBrandId.get))
	}
}

export default connect<ReduxProps, null, ComponentProps>(mapStateToProps, null)(AppointmentSalesEngineerDropdown)